import actions from './actions';

const {
    GET_ALL_JOBBOARDS
} = actions;

const initialState = {
    jobboards: null
};

const JobboardsReducer = (state = initialState, action) => {
    const { type, data } = action;
    switch (type) {
        case GET_ALL_JOBBOARDS:
            return { ...state, jobboards: data };
        default:
            return state;
    }
};
export { JobboardsReducer };
